import { resolveImagePath } from '@/utils/imageResolver';

interface ServiceCard {
  title: string;
  description: string;
  buttonText: string;
  href: string;
  imageUrl: string;
  imageAlt: string;
}

const services: ServiceCard[] = [
  {
    title: 'Learn How To Fly',
    description: 'As Chattanooga\'s highest-rated flight school, we are ready and waiting to help you start your flying journey. Live the life you\'ve been dreaming of with hands on the controls and clear blue on the horizon.',
    buttonText: 'Learn To Fly',
    href: '/flight-instruction',
    imageUrl: 'https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc7971_2023.08.21_CrystalAir_TV-1049-p-500.jpg',
    imageAlt: 'A student learning to pilot taking a introduction discovery flight at Crystal Air in Chattanooga, Tennessee'
  },
  {
    title: 'Travel On Your Own Terms',
    description: 'Whether for work or for pleasure, we have the private charter you need. Our seasoned pilots have over 50,000 combined hours of flying and all of our aircraft are maintained to the highest FAA safety standards.',
    buttonText: 'Charter A Flight',
    href: '/charter',
    imageUrl: 'https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc7972_2023.08.21_CA-ContentDay_TV-1950-p-500.jpg',
    imageAlt: 'Two women ready for vacation sitting in a private charter airplane at Crystal Air in Chattanooga, Tennessee'
  },
  {
    title: 'Management Services For Aircraft Owners',
    description: 'We manage personal aircraft of all sizes. Our team takes care of the details including routine maintenance, crew training, insurance requirements, and other management tasks.',
    buttonText: 'Management',
    href: '/aircraft-management',
    imageUrl: 'https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc7916_2022.12.04.CrystalAir_MR-5231-p-500.jpg',
    imageAlt: 'Cessna aircraft'
  },
  {
    title: 'Submit A Maintenance Request',
    description: 'We keep private aircraft in excellent condition. From minor repairs to major inspections and in-depth troubleshooting, we take care of it all with an unrivaled commitment to excellence.',
    buttonText: 'Maintenance',
    href: '/aircraft-maintenance',
    imageUrl: 'https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc7989_2023.08.21_CrystalAir_TV-0269-p-500.jpg',
    imageAlt: 'Crystal Air maintenance team working on an airplane at the Chattanooga Metropolitan Airport.'
  }
];

export function Discover() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">
            Discover The Possibilities
          </h3>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            Proudly training pilots, maintaining and managing airplanes, and flying clients all over the United States for over 25 years.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              {/* Service Image */}
              <div className="aspect-w-16 aspect-h-12 relative">
                <img
                  src={resolveImagePath(service.imageUrl)}
                  alt={service.imageAlt}
                  className="w-full h-48 object-cover"
                />
              </div>
              
              {/* Service Content */}
              <div className="p-6">
                <div className="mb-4">
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">
                    {service.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {service.description}
                  </p>
                </div>
                
                {/* CTA Button */}
                <a
                  href={service.href}
                  className="inline-block bg-blue-600 text-white px-6 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors duration-200"
                >
                  {service.buttonText}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}